export const DEFAULT_SHORT_DATE_FORMAT = 'dd/MM/yy'; // ex: 17/04/20
export const DEFAULT_DATE_FORMAT = 'dd/MM/yyyy'; // ex: 17/04/2020
export const DEFAULT_TIME_FORMAT = 'HH:mm'; // ex: 03:17
export const MERIDIEM_TIME_FORMAT = 'hh:mm a'; // ex: 03:17
export const DEFAULT_DATE_TIME_FORMAT = `${DEFAULT_DATE_FORMAT} ${DEFAULT_TIME_FORMAT}`;
export const MERIDIEM_DATE_TIME_FORMAT = `${DEFAULT_DATE_FORMAT} ${MERIDIEM_TIME_FORMAT}`;
export const ZERO_DATE = '0001-01-01T00:00:00Z';
